import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "header bg-[#232e3c] p-3 flex items-center" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = { class: "avatar bg-[#5288c1] bg-[#e17076] rounded-full size-9 flex items-center justify-center text-white font-bold" }
const _hoisted_4 = { class: "ml-3" }
const _hoisted_5 = { class: "text-white font-medium" }
const _hoisted_6 = { class: "ml-auto flex gap-3" }
const _hoisted_7 = {
  key: 0,
  class: "search-bar bg-[#232e3c] p-3 flex items-center gap-2"
}
const _hoisted_8 = {
  key: 1,
  class: "flex items-center gap-2"
}
const _hoisted_9 = { class: "text-[#8a9aa9] text-xs" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { class: "message-group flex flex-col gap-1" }
const _hoisted_13 = {
  key: 0,
  class: "avatar-container mt-1 self-end"
}
const _hoisted_14 = { class: "avatar bg-[#e17076] rounded-full size-9 flex items-center justify-center text-white font-bold" }
const _hoisted_15 = ["id"]
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = { class: "absolute bottom-1 right-2 flex items-center gap-1" }
const _hoisted_18 = { class: "text-[#8a9aa9] text-xs" }
const _hoisted_19 = { class: "button-container" }
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = ["id"]
const _hoisted_22 = { class: "flex items-start gap-3" }
const _hoisted_23 = { class: "bg-primary/20 rounded-xl p-2.5 text-primary flex-shrink-0 animate-pulse" }
const _hoisted_24 = { class: "flex-1 overflow-hidden" }
const _hoisted_25 = { class: "text-white text-sm font-semibold truncate" }
const _hoisted_26 = {
  key: 0,
  class: "text-zinc-400 text-[11px] line-clamp-2 mt-1"
}
const _hoisted_27 = { class: "mt-3 pt-3 border-t border-white/5 flex items-center justify-between text-[10px] text-zinc-500" }
const _hoisted_28 = { class: "flex items-center gap-1" }
const _hoisted_29 = ["id"]
const _hoisted_30 = ["src"]
const _hoisted_31 = ["id"]
const _hoisted_32 = ["src"]
const _hoisted_33 = ["id"]
const _hoisted_34 = { class: "p-3 flex items-center gap-2" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { class: "flex-1" }
const _hoisted_37 = { class: "h-1 bg-[#8a9aa9]/30 rounded-full w-full" }
const _hoisted_38 = { class: "text-[#8a9aa9] text-xs" }
const _hoisted_39 = ["id"]
const _hoisted_40 = ["innerHTML"]
const _hoisted_41 = { class: "absolute bottom-1 right-2 flex items-center gap-1" }
const _hoisted_42 = { class: "text-[#8a9aa9] text-xs" }
const _hoisted_43 = ["id"]
const _hoisted_44 = ["innerHTML"]
const _hoisted_45 = ["id"]
const _hoisted_46 = { class: "flex items-center gap-3" }
const _hoisted_47 = { class: "bg-[#2b5278] rounded-full p-2 text-white flex-shrink-0" }
const _hoisted_48 = { class: "flex-1 overflow-hidden" }
const _hoisted_49 = ["href"]
const _hoisted_50 = { class: "absolute bottom-1 right-2 flex items-center gap-1" }
const _hoisted_51 = { class: "text-[#8a9aa9] text-xs" }
const _hoisted_52 = { class: "input-area bg-[#17212b] border-t border-[#232e3c] p-3 flex items-center absolute bottom-0 w-full" }
const _hoisted_53 = ["disabled"]
const _hoisted_54 = {
  key: 2,
  class: "flex-1 bg-[#232e3c] rounded-lg py-2 px-4 flex items-center gap-2"
}
const _hoisted_55 = { class: "recording-indicator flex items-center gap-2" }
const _hoisted_56 = { class: "text-[#8a9aa9]" }
const _hoisted_57 = ["src"]

import { computed, ref, onMounted, nextTick, onBeforeUnmount, watch } from 'vue'
import { ArrowLeft, Search, MoreVertical, Check, Paperclip, Mic, ArrowUpRight, X, ChevronUp, ChevronDown, Play, Pause, Square, FileText, Zap, GitMerge } from 'lucide-vue-next'

// Define the MessagePreviewProp interface
export interface MessagePreviewProp {
  type: 'text' | 'button' | 'video' | 'image' | 'audio' | 'document' | 'flow'
  text?: string
  description?: string
  source?: string
  isRedirectLink?: boolean
  copyable?: boolean
  isFromAuthUser?: boolean
  sentAt?: string | Date
}

// Define the MessageGroup type
type TextButtonGroup = {
  type: 'text-button-group'
  textMessage: MessagePreviewProp
  buttonMessages: MessagePreviewProp[]
}

type IndividualMessage = {
  type: 'individual'
  message: MessagePreviewProp
}

type MessageGroup = TextButtonGroup | IndividualMessage

type SearchResult = {
  groupIndex: number
  text: string
}

type AudioElement = {
  src: string
  isPlaying: boolean
  currentTime: number
  duration: number
  progress: number
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TelegramMessagePreview',
  props: {
  messages: {
    type: Array as () => MessagePreviewProp[],
    default: () => []
  },
  sender: {
    type: String,
    default: 'Bot'
  },
  sentAt: {
    type: [String, Date],
    default: () => new Date()
  },
  showAvatar: {
    type: Boolean,
    default: true
  },
  class: {
    type: String,
    default: ''
  },
  disableInput: {
    type: Boolean,
    default: false
  },
  disableMic: {
    type: Boolean,
    default: false
  },
  disableAttachments: {
    type: Boolean,
    default: false
  }
},
  emits: ['send-message', 'go-back', 'audio-recorded'],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit

// Search functionality
const isSearchActive = ref(false)
const searchQuery = ref('')
const searchResults = ref<SearchResult[]>([])
const currentResultIndex = ref(0)
const messagesContainerRef = ref<HTMLElement | null>(null)
const searchInputRef = ref<HTMLInputElement | null>(null)

// Audio recording functionality
const isRecording = ref(false)
const mediaRecorder = ref<MediaRecorder | null>(null)
const audioChunks = ref<BlobPart[]>([])
const recordingTime = ref(0)
const recordingTimer = ref<number | null>(null)
const audioElements = ref<AudioElement[]>([])
const audioRefs = ref<HTMLAudioElement[]>([])

// Toggle search visibility
const toggleSearch = () => {
  isSearchActive.value = !isSearchActive.value
  if (isSearchActive.value) {
    nextTick(() => {
      searchInputRef.value?.focus()
    })
  } else {
    clearSearch()
  }
}

// Clear search
const clearSearch = () => {
  searchQuery.value = ''
  searchResults.value = []
  currentResultIndex.value = 0
}

// Handle search input
const handleSearch = () => {
  if (!searchQuery.value.trim()) {
    searchResults.value = []
    return
  }
  
  const results: SearchResult[] = []
  
  // Search through all message groups
  messageGroups.value.forEach((group, groupIndex) => {
    if (group.type === 'text-button-group') {
      // Search in text message
      if (group.textMessage.text && group.textMessage.text.toLowerCase().includes(searchQuery.value.toLowerCase())) {
        results.push({
          groupIndex,
          text: group.textMessage.text
        })
      }
      
      // Search in button messages
      group.buttonMessages.forEach(buttonMsg => {
        if (buttonMsg.text && buttonMsg.text.toLowerCase().includes(searchQuery.value.toLowerCase())) {
          results.push({
            groupIndex,
            text: buttonMsg.text
          })
        }
      })
    } else if (group.type === 'individual' && group.message.text) {
      // Search in individual message
      if (group.message.text.toLowerCase().includes(searchQuery.value.toLowerCase())) {
        results.push({
          groupIndex,
          text: group.message.text
        })
      }
    }
  })
  
  searchResults.value = results
  currentResultIndex.value = results.length > 0 ? 0 : -1
  
  // Scroll to first result if found
  if (results.length > 0) {
    scrollToResult(0)
  }
}

// Navigate to previous search result
const navigateToPrevResult = () => {
  if (searchResults.value.length === 0) return
  
  currentResultIndex.value = (currentResultIndex.value - 1 + searchResults.value.length) % searchResults.value.length
  scrollToResult(currentResultIndex.value)
}

// Navigate to next search result
const navigateToNextResult = () => {
  if (searchResults.value.length === 0) return
  
  currentResultIndex.value = (currentResultIndex.value + 1) % searchResults.value.length
  scrollToResult(currentResultIndex.value)
}

// Scroll to a specific search result
const scrollToResult = (index: number) => {
  if (!messagesContainerRef.value) return
  
  const resultGroupIndex = searchResults.value[index].groupIndex
  const messageElement = document.getElementById(`message-${resultGroupIndex}`)
  
  if (messageElement) {
    messageElement.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }
}

// Check if a message group is highlighted (current search result)
const isHighlighted = (groupIndex: number): boolean => {
  if (searchResults.value.length === 0 || currentResultIndex.value === -1) return false
  return searchResults.value[currentResultIndex.value].groupIndex === groupIndex
}

// Highlight search text in message content
const highlightSearchText = (text: string): string => {
  if (!searchQuery.value.trim() || !text) return text
  
  const regex = new RegExp(`(${escapeRegExp(searchQuery.value)})`, 'gi')
  return text.replace(regex, '<span class="search-text-highlight">$1</span>')
}

// Escape special characters in string for use in regex
const escapeRegExp = (string: string): string => {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

// Helper function to check if a message group is from authenticated user
const isMessageFromAuthUser = (group: MessageGroup): boolean => {
  if (group.type === 'text-button-group') {
    return group.textMessage.isFromAuthUser || false
  }
  return group.message.isFromAuthUser || false
}

// Group messages to handle text+button combinations
const messageGroups = computed<MessageGroup[]>(() => {
  const groups: MessageGroup[] = [];
  let i = 0;
  
  while (i < props.messages.length) {
    const message = props.messages[i];
    
    // Check if this is a text message followed by button(s)
    if (message.type === 'text') {
      // Look ahead to see if there are buttons following this text
      let j = i + 1;
      const buttonMessages: MessagePreviewProp[] = [];
      
      while (j < props.messages.length && props.messages[j].type === 'button') {
        buttonMessages.push(props.messages[j]);
        j++;
      }
      
      // If we found buttons, create a text-button group
      if (buttonMessages.length > 0) {
        groups.push({
          type: 'text-button-group',
          textMessage: message,
          buttonMessages
        });
        
        // Skip the processed messages
        i = j;
        continue;
      }
    }
    
    // If not part of a group, add as individual message
    groups.push({
      type: 'individual',
      message
    });
    
    i++;
  }
  
  return groups;
});

const isLastMessage = (message: MessagePreviewProp): boolean => {
  return props.messages[props.messages.length - 1] === message;
};

const getInitials = (name: string): string => {
  if (!name) return 'B'
  return name.split(' ').map(n => n[0]).join('').toUpperCase().substring(0, 2)
}

const formatTime = (timestamp: string | Date): string => {
  if (!timestamp) return '00:59'
  const date = typeof timestamp === 'string' ? new Date(timestamp) : timestamp
  return date.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit', timeZone: 'UTC' })
}

// Format audio time (seconds to MM:SS)
const formatAudioTime = (seconds: number): string => {
  const minutes = Math.floor(seconds / 60)
  const remainingSeconds = Math.floor(seconds % 60)
  return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`
}

// Toggle audio recording
const toggleRecording = async () => {
  if (isRecording.value) {
    stopRecording()
  } else {
    await startRecording()
  }
}

// Start audio recording
const startRecording = async () => {
  try {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true })
    
    mediaRecorder.value = new MediaRecorder(stream)
    audioChunks.value = []
    recordingTime.value = 0
    
    mediaRecorder.value.ondataavailable = (event) => {
      audioChunks.value.push(event.data)
    }
    
    mediaRecorder.value.onstop = () => {
      const audioBlob = new Blob(audioChunks.value, { type: 'audio/webm' })
      const audioUrl = URL.createObjectURL(audioBlob)
      
      // Emit the recorded audio to parent component
      emit('audio-recorded', {
        blob: audioBlob,
        url: audioUrl,
        duration: recordingTime.value
      })
      
      // Create a message with the audio
      const audioMessage: MessagePreviewProp = {
        type: 'audio',
        source: audioUrl,
        isFromAuthUser: true,
        sentAt: new Date().toISOString()
      }
      
      // Add to audio elements for playback
      audioElements.value.push({
        src: audioUrl,
        isPlaying: false,
        currentTime: 0,
        duration: recordingTime.value,
        progress: 0
      })
      
      // Emit send-message event with the audio message
      emit('send-message', audioMessage)
      
      // Stop all tracks
      stream.getTracks().forEach(track => track.stop())
    }
    
    // Start recording
    mediaRecorder.value.start()
    isRecording.value = true
    
    // Start timer
    recordingTimer.value = window.setInterval(() => {
      recordingTime.value += 1
    }, 1000)
    
  } catch (error) {
    console.error('Error accessing microphone:', error)
  }
}

// Stop audio recording
const stopRecording = () => {
  if (mediaRecorder.value && mediaRecorder.value.state !== 'inactive') {
    mediaRecorder.value.stop()
    isRecording.value = false
    
    // Clear timer
    if (recordingTimer.value) {
      clearInterval(recordingTimer.value)
      recordingTimer.value = null
    }
  }
}

// Audio playback functions
const toggleAudioPlay = (src: string) => {
  const audioIndex = audioElements.value.findIndex(audio => audio.src === src)
  if (audioIndex === -1) return
  
  const audio = audioRefs.value[audioIndex]
  if (!audio) return
  
  if (audioElements.value[audioIndex].isPlaying) {
    audio.pause()
    audioElements.value[audioIndex].isPlaying = false
  } else {
    // Pause all other playing audio
    audioElements.value.forEach((a, i) => {
      if (i !== audioIndex && a.isPlaying) {
        audioRefs.value[i]?.pause()
        a.isPlaying = false
      }
    })
    
    audio.play()
    audioElements.value[audioIndex].isPlaying = true
  }
}

const isAudioPlaying = (src: string): boolean => {
  const audioIndex = audioElements.value.findIndex(audio => audio.src === src)
  if (audioIndex === -1) return false
  return audioElements.value[audioIndex].isPlaying
}

const getAudioProgress = (src: string): number => {
  const audioIndex = audioElements.value.findIndex(audio => audio.src === src)
  if (audioIndex === -1) return 0
  return audioElements.value[audioIndex].progress
}

const getAudioCurrentTime = (src: string): number => {
  const audioIndex = audioElements.value.findIndex(audio => audio.src === src)
  if (audioIndex === -1) return 0
  return audioElements.value[audioIndex].currentTime
}

// Update audio progress
const updateAudioProgress = () => {
  audioRefs.value.forEach((audio, index) => {
    if (!audio) return
    
    audioElements.value[index].currentTime = audio.currentTime
    audioElements.value[index].duration = audio.duration || 0
    audioElements.value[index].progress = audio.duration ? (audio.currentTime / audio.duration) * 100 : 0
    
    // Check if audio has ended
    if (audio.ended) {
      audioElements.value[index].isPlaying = false
    }
  })
}

// Add keyboard shortcuts for search
onMounted(() => {
  window.addEventListener('keydown', (e) => {
    // Ctrl+F or Cmd+F to open search
    if ((e.ctrlKey || e.metaKey) && e.key === 'f') {
      e.preventDefault()
      toggleSearch()
    }
    
    // Escape to close search
    if (e.key === 'Escape' && isSearchActive.value) {
      toggleSearch()
    }
    
    // Enter to navigate to next result
    if (e.key === 'Enter' && isSearchActive.value) {
      navigateToNextResult()
    }
    
    // Shift+Enter to navigate to previous result
    if (e.key === 'Enter' && e.shiftKey && isSearchActive.value) {
      navigateToPrevResult()
    }
  })
  
  // Set up audio progress update interval
  const progressInterval = setInterval(updateAudioProgress, 100)
  
  onBeforeUnmount(() => {
    clearInterval(progressInterval)
    
    // Clean up recording if active
    if (isRecording.value) {
      stopRecording()
    }
    
    // Release object URLs
    audioElements.value.forEach(audio => {
      URL.revokeObjectURL(audio.src)
    })
  })
})

// Add messages to audio elements when they're added
const updateAudioElementsFromMessages = () => {
  props.messages.forEach(message => {
    if (message.type === 'audio' && message.source) {
      // Check if this audio source is already in our elements
      const exists = audioElements.value.some(audio => audio.src === message.source)
      if (!exists) {
        audioElements.value.push({
          src: message.source,
          isPlaying: false,
          currentTime: 0,
          duration: 0,
          progress: 0
        })
      }
    }
  })
}

// Watch for new messages with audio
watch(() => props.messages, () => {
  updateAudioElementsFromMessages()
}, { deep: true })

// Initialize audio elements from existing messages
updateAudioElementsFromMessages()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["telegram-preview max-h-full bg-[#0e1621] relative pb-[65px]", __props.class])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('go-back'))),
          class: "text-[#8a9aa9] mr-3 size-5"
        }, [
          _createVNode(_unref(ArrowLeft), { class: "text-[#8a9aa9] mr-3 size-5" })
        ]),
        _createElementVNode("div", _hoisted_3, _toDisplayString(getInitials(__props.sender || 'Bot')), 1),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h3", _hoisted_5, _toDisplayString(__props.sender || 'Bot'), 1),
          _cache[3] || (_cache[3] = _createElementVNode("p", { class: "text-[#8a9aa9] text-xs" }, "online", -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          onClick: toggleSearch,
          class: "text-[#8a9aa9] size-5"
        }, [
          _createVNode(_unref(Search), { class: "text-[#8a9aa9] size-5" })
        ])
      ])
    ]),
    (isSearchActive.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("button", {
            onClick: toggleSearch,
            class: "text-[#8a9aa9]"
          }, [
            _createVNode(_unref(ArrowLeft), { class: "text-[#8a9aa9] size-5" })
          ]),
          _withDirectives(_createElementVNode("input", {
            ref_key: "searchInputRef",
            ref: searchInputRef,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchQuery).value = $event)),
            class: "bg-[#17212b] rounded-lg flex-1 py-2 px-4 text-white placeholder:text-[#8a9aa9] border-[unset] ring-[unset] focus:outline-none",
            placeholder: "Pesquisar...",
            onInput: handleSearch
          }, null, 544), [
            [_vModelText, searchQuery.value]
          ]),
          (searchQuery.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: clearSearch,
                class: "text-[#8a9aa9]"
              }, [
                _createVNode(_unref(X), { class: "text-[#8a9aa9] size-5" })
              ]))
            : _createCommentVNode("", true),
          (searchResults.value.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(currentResultIndex.value + 1) + "/" + _toDisplayString(searchResults.value.length), 1),
                _createElementVNode("button", {
                  onClick: navigateToPrevResult,
                  disabled: searchResults.value.length === 0,
                  class: "text-[#8a9aa9] disabled:opacity-50"
                }, [
                  _createVNode(_unref(ChevronUp), { class: "text-[#8a9aa9] size-5" })
                ], 8, _hoisted_10),
                _createElementVNode("button", {
                  onClick: navigateToNextResult,
                  disabled: searchResults.value.length === 0,
                  class: "text-[#8a9aa9] disabled:opacity-50"
                }, [
                  _createVNode(_unref(ChevronDown), { class: "text-[#8a9aa9] size-5" })
                ], 8, _hoisted_11)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      id: "messages-container",
      ref_key: "messagesContainerRef",
      ref: messagesContainerRef,
      class: "messages-container max-h-[80dvh] md:max-h-[74dvh] overflow-auto bg-[#0e1621] p-4 min-h-[350px] overflow-y-auto flex flex-col-reverse"
    }, [
      _createElementVNode("div", _hoisted_12, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messageGroups.value, (group, groupIndex) => {
          return (_openBlock(), _createElementBlock("div", {
            key: `group-${groupIndex}`,
            class: _normalizeClass(["flex items-start gap-2", { 'flex-row-reverse': isMessageFromAuthUser(group) }])
          }, [
            (__props.showAvatar && !isMessageFromAuthUser(group))
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, _toDisplayString(getInitials(__props.sender || 'Bot')), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(["flex flex-col items-start gap-1 max-w-[80dvw] md:max-w-[23dvw]", { 'items-end': isMessageFromAuthUser(group) }])
            }, [
              (group.type === 'text-button-group')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["text-button-group inline-flex flex-col", { 'search-highlight': isHighlighted(groupIndex) }]),
                    id: `message-${groupIndex}`
                  }, [
                    (group.textMessage)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass(["message-bubble p-3 text-sm break-words rounded-b-none w-full", [
                  isMessageFromAuthUser(group)
                    ? 'bg-[#182533] text-white rounded-lg rounded-br-none' 
                    : 'bg-[#182533] rounded-lg rounded-b-none',
                  { 'text-blue-400': group.textMessage.copyable, 'text-white': !group.textMessage.copyable }
                ]])
                        }, [
                          _createElementVNode("span", {
                            class: "break-all",
                            innerHTML: highlightSearchText(group.textMessage.text || '')
                          }, null, 8, _hoisted_16),
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("span", _hoisted_18, _toDisplayString(formatTime(group.textMessage.sentAt ?? new Date())), 1),
                            _createVNode(_unref(Check), { class: "text-[#8a9aa9] size-3" })
                          ])
                        ], 2))
                      : _createCommentVNode("", true),
                    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "h-[2px]" }, null, -1)),
                    _createElementVNode("div", _hoisted_19, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.buttonMessages, (buttonMsg, btnIndex) => {
                        return (_openBlock(), _createElementBlock("button", {
                          key: `button-${btnIndex}`,
                          class: _normalizeClass(["telegram-button font-normal py-2.5 px-3 text-center w-full text-sm relative", [
                    isMessageFromAuthUser(group) ? 'bg-[#222e3a] hover:bg-[#2c3b4b]' : 'bg-[#222e3a] hover:bg-[#2c3b4b]',
                    {
                      'rounded-t-none rounded-b-none mb-[2px]': btnIndex > 0 && btnIndex < group.buttonMessages.length - 1,
                      'rounded-t-none mb-[2px]': btnIndex === 0,
                      'rounded-b-md mb-[2px]': btnIndex === group.buttonMessages.length - 1
                    }
                  ]])
                        }, [
                          _createElementVNode("span", {
                            innerHTML: highlightSearchText(buttonMsg.text || '')
                          }, null, 8, _hoisted_20),
                          (buttonMsg.isRedirectLink)
                            ? (_openBlock(), _createBlock(_unref(ArrowUpRight), {
                                key: 0,
                                class: "size-3 absolute right-1 top-1 text-white"
                              }))
                            : _createCommentVNode("", true)
                        ], 2))
                      }), 128))
                    ])
                  ], 10, _hoisted_15))
                : (group.message.type === 'flow')
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "flow-bubble p-4 text-sm relative break-words min-w-[240px] border border-primary/20 bg-gradient-to-br from-[#182533] to-[#1e2a38] rounded-lg text-white",
                      id: `message-${groupIndex}`
                    }, [
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                          _createVNode(_unref(GitMerge), { class: "size-6" })
                        ]),
                        _createElementVNode("div", _hoisted_24, [
                          _cache[5] || (_cache[5] = _createElementVNode("p", { class: "text-[10px] uppercase tracking-wider text-primary/70 font-bold mb-1" }, "Gatilho de Fluxo", -1)),
                          _createElementVNode("p", _hoisted_25, _toDisplayString(group.message.text), 1),
                          (group.message.description)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_26, _toDisplayString(group.message.description), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("span", _hoisted_28, [
                          _createVNode(_unref(Zap), { class: "size-3 text-yellow-500" }),
                          _cache[6] || (_cache[6] = _createTextVNode(" Automático"))
                        ]),
                        _createElementVNode("span", null, _toDisplayString(formatTime(group.message.sentAt ?? new Date())), 1)
                      ])
                    ], 8, _hoisted_21))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      (group.message.type === 'image' && group.message.source)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(["media-bubble overflow-hidden relative w-full", [
                  isMessageFromAuthUser(group)
                    ? 'bg-[#182533] rounded-lg rounded-br-none' 
                    : 'bg-[#182533] rounded-lg'
                ]]),
                            id: `message-${groupIndex}`
                          }, [
                            _createElementVNode("img", {
                              src: group.message.source,
                              alt: "Image",
                              class: "w-full max-h-[330px] object-cover"
                            }, null, 8, _hoisted_30)
                          ], 10, _hoisted_29))
                        : (group.message.type === 'video' && group.message.source)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: _normalizeClass(["media-bubble overflow-hidden relative w-full", [
                  isMessageFromAuthUser(group)
                    ? 'bg-[#182533] rounded-lg rounded-br-none' 
                    : 'bg-[#182533] rounded-lg'
                ]]),
                              id: `message-${groupIndex}`
                            }, [
                              _createElementVNode("video", {
                                src: group.message.source,
                                controls: "",
                                class: "w-full max-h-[200px] object-cover"
                              }, null, 8, _hoisted_32)
                            ], 10, _hoisted_31))
                          : (group.message.type == 'audio')
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 2,
                                class: _normalizeClass(["media-bubble overflow-hidden relative w-full", [
                  isMessageFromAuthUser(group)
                    ? 'bg-[#182533] rounded-lg rounded-br-none' 
                    : 'bg-[#182533] rounded-lg'
                ]]),
                                id: `message-${groupIndex}`
                              }, [
                                _createElementVNode("div", _hoisted_34, [
                                  _createElementVNode("button", {
                                    onClick: ($event: any) => (toggleAudioPlay(group.message.source as string)),
                                    class: "bg-[#5288c1] rounded-full size-8 flex items-center justify-center"
                                  }, [
                                    (!isAudioPlaying(group.message.source as string))
                                      ? (_openBlock(), _createBlock(_unref(Play), {
                                          key: 0,
                                          class: "size-4 text-white"
                                        }))
                                      : (_openBlock(), _createBlock(_unref(Pause), {
                                          key: 1,
                                          class: "size-4 text-white"
                                        }))
                                  ], 8, _hoisted_35),
                                  _createElementVNode("div", _hoisted_36, [
                                    _createElementVNode("div", _hoisted_37, [
                                      _createElementVNode("div", {
                                        class: "h-1 bg-[#5288c1] rounded-full",
                                        style: _normalizeStyle({ width: getAudioProgress(group.message.source as string) + '%' })
                                      }, null, 4)
                                    ])
                                  ]),
                                  _createElementVNode("span", _hoisted_38, _toDisplayString(formatAudioTime(getAudioCurrentTime(group.message.source as string))), 1)
                                ])
                              ], 10, _hoisted_33))
                            : (group.message.type === 'text')
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 3,
                                  class: _normalizeClass(["message-bubble p-3 text-sm relative break-words", [
                  isMessageFromAuthUser(group)
                    ? 'bg-[#182533] rounded-lg rounded-br-none' 
                    : 'bg-[#182533] rounded-lg',
                  { 'text-blue-400': group.message.copyable, 'text-white': !group.message.copyable },
                  { 'search-highlight': isHighlighted(groupIndex) }
                ]]),
                                  id: `message-${groupIndex}`
                                }, [
                                  _createElementVNode("span", {
                                    class: "break-all",
                                    innerHTML: highlightSearchText(group.message.text || '')
                                  }, null, 8, _hoisted_40),
                                  _createElementVNode("div", _hoisted_41, [
                                    _createElementVNode("span", _hoisted_42, _toDisplayString(formatTime(group.message.sentAt ?? new Date())), 1),
                                    _createVNode(_unref(Check), { class: "text-[#8a9aa9] size-3" })
                                  ])
                                ], 10, _hoisted_39))
                              : (group.message.type === 'button')
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 4,
                                    class: _normalizeClass(["telegram-button font-normal py-2.5 px-8 rounded-md text-center text-sm relative", [
                  isMessageFromAuthUser(group) ? 'bg-[#222e3a] hover:bg-[#2c3b4b]' : 'bg-[#222e3a] hover:bg-[#2c3b4b]',
                  { 'search-highlight': isHighlighted(groupIndex) }
                ]]),
                                    id: `message-${groupIndex}`
                                  }, [
                                    _createElementVNode("span", {
                                      innerHTML: highlightSearchText(group.message.text || '')
                                    }, null, 8, _hoisted_44),
                                    (group.message.isRedirectLink)
                                      ? (_openBlock(), _createBlock(_unref(ArrowUpRight), {
                                          key: 0,
                                          class: "size-3 absolute right-1 top-1 text-white"
                                        }))
                                      : _createCommentVNode("", true)
                                  ], 10, _hoisted_43))
                                : (group.message.type === 'document' && group.message.source)
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 5,
                                      class: _normalizeClass(["message-bubble p-3 text-sm relative break-words min-w-[200px]", [
                  isMessageFromAuthUser(group)
                    ? 'bg-[#182533] rounded-lg rounded-br-none' 
                    : 'bg-[#182533] rounded-lg',
                   { 'search-highlight': isHighlighted(groupIndex) }
                ]]),
                                      id: `message-${groupIndex}`
                                    }, [
                                      _createElementVNode("div", _hoisted_46, [
                                        _createElementVNode("div", _hoisted_47, [
                                          _createVNode(_unref(FileText), { class: "size-6" })
                                        ]),
                                        _createElementVNode("div", _hoisted_48, [
                                          _cache[7] || (_cache[7] = _createElementVNode("p", { class: "text-white text-sm truncate font-medium" }, "Arquivo", -1)),
                                          _createElementVNode("a", {
                                            href: group.message.source,
                                            target: "_blank",
                                            class: "text-[#64b3f4] text-xs hover:underline truncate block"
                                          }, "Baixar Documento", 8, _hoisted_49)
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_50, [
                                        _createElementVNode("span", _hoisted_51, _toDisplayString(formatTime(group.message.sentAt ?? new Date())), 1),
                                        _createVNode(_unref(Check), { class: "text-[#8a9aa9] size-3" })
                                      ])
                                    ], 10, _hoisted_45))
                                  : _createCommentVNode("", true)
                    ], 64))
            ], 2)
          ], 2))
        }), 128))
      ])
    ], 512),
    _createElementVNode("div", _hoisted_52, [
      (!__props.disableAttachments)
        ? (_openBlock(), _createBlock(_unref(Paperclip), {
            key: 0,
            class: "text-[#8a9aa9] size-5 mr-3"
          }))
        : _createCommentVNode("", true),
      (!isRecording.value)
        ? (_openBlock(), _createElementBlock("input", {
            key: 1,
            disabled: __props.disableInput,
            onKeydown: _cache[2] || (_cache[2] = _withKeys(($event: any) => {_ctx.$emit('send-message', ($event.target as HTMLInputElement).value); ($event.target as HTMLInputElement).value = ''}, ["enter"])),
            class: "bg-[#232e3c] rounded-lg flex-1 py-2 px-4 placeholder:text-[#8a9aa9] border-[unset] ring-[unset] focus:outline-none",
            placeholder: "Mensagem"
          }, null, 40, _hoisted_53))
        : (_openBlock(), _createElementBlock("div", _hoisted_54, [
            _createElementVNode("div", _hoisted_55, [
              _cache[8] || (_cache[8] = _createElementVNode("div", { class: "size-2 rounded-full bg-red-500 animate-pulse" }, null, -1)),
              _createElementVNode("span", _hoisted_56, _toDisplayString(formatAudioTime(recordingTime.value)), 1)
            ]),
            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "flex-1" }, [
              _createElementVNode("div", { class: "h-1 bg-[#8a9aa9]/30 rounded-full w-full" }, [
                _createElementVNode("div", { class: "h-1 bg-red-500 rounded-full recording-progress" })
              ])
            ], -1))
          ])),
      (!__props.disableMic)
        ? (_openBlock(), _createElementBlock("button", {
            key: 3,
            onClick: toggleRecording,
            class: _normalizeClass(["ml-3 flex items-center justify-center", { 'text-red-500': isRecording.value, 'text-[#8a9aa9]': !isRecording.value }])
          }, [
            (!isRecording.value)
              ? (_openBlock(), _createBlock(_unref(Mic), {
                  key: 0,
                  class: "size-5"
                }))
              : (_openBlock(), _createBlock(_unref(Square), {
                  key: 1,
                  class: "size-5"
                }))
          ], 2))
        : _createCommentVNode("", true)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(audioElements.value, (audio, index) => {
      return (_openBlock(), _createElementBlock("audio", {
        key: index,
        src: audio.src,
        ref_for: true,
        ref_key: "audioRefs",
        ref: audioRefs
      }, null, 8, _hoisted_57))
    }), 128))
  ], 2))
}
}

})